/**
 *	This code was gladly borrowed from
 *	https://github.com/getsentry/sentry-javascript/blob/d136f4e0bca43cda21db42da4e84bbe3448a70a1/packages/utils/src/instrument.ts
 *  Please note that there might be a leak tweak or two :)
 */ import isString from "ramda-extension/es/isString";
import { instrumentTypes } from '../../constants';
import { createEventDescription } from '../../utils/description';
import { triggerHandlers } from '../../utils/handlers';
import { fill } from '../../utils/object';
export const instrumentConsole = ()=>{
    if (!('console' in window)) {
        return;
    }
    const createConsoleInteractionEvent = createEventDescription(instrumentTypes.CONSOLE);
    [
        'debug',
        'info',
        'warn',
        'error',
        'log',
        'assert'
    ].forEach(function(level) {
        if (!(level in window.console)) {
            return;
        }
        fill(window.console, level, function(originalConsoleLevel) {
            return (...args)=>{
                triggerHandlers(instrumentTypes.CONSOLE, createConsoleInteractionEvent({
                    args: args.filter(isString),
                    level
                }));
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, window.console, args);
                }
            };
        });
    });
};
